import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-xl-10 mb-5" }
const _hoisted_2 = { class: "card-header d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Multisig TX", -1)
const _hoisted_4 = {
  key: 0,
  class: "card-body"
}
const _hoisted_5 = { class: "border border-danger border-dashed rounded badge badge-light-danger py-3 px-4 me-6 mb-3 text-center" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-bolder text-danger" }, " Expiration: ", -1)
const _hoisted_8 = { class: "fs-7 fw-bolder text-danger ms-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px" }, "Authorization"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px" }, "Action"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px" }, "Data")
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-bolder" }, "Account:", -1)
const _hoisted_15 = { class: "mt-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-bolder" }, "Permission:", -1)
const _hoisted_17 = { class: "text-hover-info ms-2" }
const _hoisted_18 = { class: "d-flex flex-column align-items-start" }
const _hoisted_19 = { class: "fs-7 badge badge-light-primary border-dashed border-1 border-primary m-1" }
const _hoisted_20 = {
  key: 1,
  class: "card-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-success",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.Approve()))
        }, "Approve"),
        _createElementVNode("button", {
          class: "btn btn-sm btn-primary mx-2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Execute()))
        }, "Execute"),
        _createElementVNode("button", {
          class: "btn btn-sm btn-info",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copy()))
        }, "Copy")
      ])
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.actions.expiration), 1)
            ])
          ]),
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions.actions, (action, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    style: {"vertical-align":"top"}
                  }, [
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(action.authorization, (auth, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "d-flex flex-column align-items-start border border-1 border-grey-400 rounded my-1 p-2",
                          style: {"width":"fit-content"}
                        }, [
                          _createElementVNode("div", null, [
                            _hoisted_14,
                            _createVNode(_component_router_link, {
                              to: `/account/${auth.actor}`,
                              class: "text-hover-info fs-6 ms-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(auth.actor), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("span", _hoisted_17, _toDisplayString(auth.permission), 1)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_router_link, {
                          to: `/account/${action.account}`,
                          class: "fs-7 badge badge-light-info border-dashed border-1 border-info m-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(action.account), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(action.name), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(action.data, (data, key) => {
                        return (_openBlock(), _createElementBlock("div", { key: key }, _toDisplayString(key) + " : " + _toDisplayString(data), 1))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_Loading, { height: '150px' })
        ]))
  ]))
}